// extracted by mini-css-extract-plugin
export default {"container":"ConfirmationModal_container__6stEX","title":"ConfirmationModal_title__BfA1j","footer":"ConfirmationModal_footer__e+n5b"};